import DepsService from 'services/dependencies';

const CONTEXT = 'multistore';

export const fetchRetailerDetails = async (retailerId) => {
  const { url } = DepsService.rest.multiStore.shortRetailerInfo;
  const queryParams = {};
  const urlParams = { retailerId };
  const { retailer } = await DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
  return retailer;
};

const changeLocation = (retailerId, userId) => {
  const { url } = DepsService.rest.multiStore.select;
  const queryParams = { userId };
  const payload = { retailerId };

  return DepsService.restSrv.update(CONTEXT, url, payload, queryParams);
};

export default {
  fetchRetailerDetails,
  changeLocation,
};



// WEBPACK FOOTER //
// ./src/modules/utils/resources/utils.api.js